/* eslint-disable arrow-body-style */
import React from 'react';
import { connect } from 'react-redux';
import { Spinner } from 'reactstrap';
import { loadRecords } from '../../actions/records';
import RecordRow from './RecordRow';

class RecordList extends React.PureComponent {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({ type: 'CLEAR_RECORD_BOOK' });
    dispatch({ type: 'SET_RECORDS_LOADING', payload: true });
    loadRecords()
      .then(() => {
        dispatch({ type: 'SET_RECORDS_LOADING', payload: false });
      }).catch(() => {
        dispatch({ type: 'SET_RECORDS_LOADING', payload: false });
      });
  }

  render() {
    const {
      recordBook,
      recordPageIdx,
      recordsLoading,
    } = this.props;

    // group records by enrollment
    let currentEnrollment = 0;
    let alternate = false;

    return (recordsLoading || !recordBook || !recordBook[recordPageIdx])
      ? (
        <tbody>
          <tr>
            <div
              className="m-4 text-center"
              style={{
                position: 'fixed',
                left: '40vw',
                opacity: recordsLoading ? '1' : '0',
                transition: 'all 1s ease',
              }}
            >
              <Spinner style={{ width: '5rem', height: '5rem' }} type="grow" color="info" />
              <Spinner style={{ width: '5rem', height: '5rem' }} type="grow" color="info" />
              <Spinner style={{ width: '5rem', height: '5rem' }} type="grow" color="info" />
            </div>
          </tr>
        </tbody>
      )
      : (
        <tbody
          style={{
            opacity: recordsLoading ? 0 : 1,
            transition: 'all 1s ease',
          }}
        >
          {recordBook[0].length === 0
            ? (
              <tr
                className="fst-italic fs-4"
                style={{ height: '150px' }}
              >
                <td
                  className="ps-5"
                  colSpan={20}
                >
                  {'Looks like there are no call records.'}
                </td>
              </tr>
            )
            : null}
          {recordBook[recordPageIdx].map((record, idx) => {
            const a = recordsLoading ? '0' : '1';
            const recordStyle = {
              color: `rgba(0, 0, 0, ${a})`,
              backgroundColor: alternate
                ? `rgba(255, 255, 255, ${a})`
                : `rgba(255, 255, 255, ${a})`,
              transition: 'all 5.5s',
            };
            if (currentEnrollment !== record.enrollment_id) {
              alternate = !alternate;
            }
            currentEnrollment = record.enrollment_id;
            return (
              <>
                {idx > 0
                  ? (
                    <tr>
                      <td
                        className="w-100"
                        colSpan="20"
                        style={{
                          height: '22px',
                          // backgroundColor: 'rgb(150, 150, 150)',
                        }}
                      />
                    </tr>
                  )
                  : null}
                <tr>
                  <td
                    className="w-100 bg-secondary text-white ps-4"
                    colSpan="20"
                  >
                    Enrollment (ID #{record.enrollment_id})
                  </td>
                </tr>
                {record.enrollment_calls.map((call, callIdx) => {
                  return (
                    <RecordRow
                      record={call}
                      idx={callIdx}
                      key={`${call.contact_id}-${call.call_start}`}
                      style={recordStyle}
                      className="shadow-lg"
                    />
                  );
                })}
              </>
            );
          })}
        </tbody>
      );
  }
}

const mapStateToProps = (store) => ({
  recordBook: store.records.recordBook,
  recordPageIdx: store.records.recordPageIdx,

  recordsLoading: store.records.loading,
  sortTerm: store.records.sortTerm,
  desc: store.records.desc,
});

export default connect(mapStateToProps)(RecordList);
